import './assets/background.css';
import './assets/chessadministrator.css';
import "@vueform/multiselect/themes/default.css"

import {createApp} from 'vue'
import App from './App.vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import router from "@/router";
import {Auth} from "@aws-amplify/auth";
import {Amplify} from '@aws-amplify/core';
//import user from "@/components/users";
import {library} from '@fortawesome/fontawesome-svg-core'
import {createI18n} from 'vue-i18n'
import {
    faBars,
    faCheck,
    faChevronLeft,
    faChevronRight,
    faCloudUploadAlt,
    faCog,
    faCopyright,
    faEnvelope,
    faExclamationCircle,
    faExclamationTriangle,
    faFileContract,
    faHeart,
    faHeartbeat,
    faHome,
    faInfoCircle,
    faLink,
    faLock,
    faEdit,
    faPlus,
    faPlusSquare,
    faSearch,
    faSignInAlt,
    faSignOutAlt,
    faTicketAlt,
    faTimes,
    faCaretSquareDown,
    faCaretSquareUp,
    faTrash,
    faTrophy,
    faUniversity,
    faUnlock,
    faUser,
    faUsers,
    faWrench
} from '@fortawesome/free-solid-svg-icons'
import nl from '@/locale/nl'
import en from '@/locale/en'
import debounce from '@/directives/debouncer' 
import {createCAUser} from "@/globals/registered-user";
import {createCA_Storage} from "@/globals/storage";

library.add(faBars, faCheck, faChevronLeft, faChevronRight, faCloudUploadAlt, faCog, faCopyright, faEnvelope, faExclamationCircle, 
    faExclamationTriangle, faFileContract, faHeart, faHeartbeat, faHome, faInfoCircle, faLink, faLock, faEdit, faPlus, faPlusSquare, faSearch, 
    faSignInAlt, faSignOutAlt, faTicketAlt, faTimes, faCaretSquareDown, faCaretSquareUp, faTrash, faTrophy, 
    faUniversity, faUnlock, faUser, faUsers, faWrench)

Amplify.configure({
    API: {
        endpoints: [
            {
                name: "api",
                endpoint: process.env.VUE_APP_APIURL //"https://localhost:5001/api",
            },
            {
                name: "authenticated-api",
                endpoint: "https://api.schaaktoernooien.nl",
                custom_header: async () => {
                    // return { Authorization : 'token' }
                    // Alternatively, with Cognito User Pools use this:
                    // return { Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}` }
                    return {Authorization: `${(await Auth.currentSession()).getIdToken().getJwtToken()}`}
                }
            },
        ]
    }
});

const messages  = {
    nl: nl,
    en: en
}

const i18n = createI18n({
    locale: 'nl',
    messages
})

const CAUser = createCAUser();

const CA_Storage = createCA_Storage();

createApp(App)
    .component('font-awesome-icon', FontAwesomeIcon)

    .directive('debounce', (el,binding) => debounce(el,binding))

    .use(router)
    .use(i18n)
//    .use(user)
    .use(CAUser)
    .use(CA_Storage)

    .mount('#app')


    
